import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

const NewsAndUpdates = () => {
  return (
    <Swiper
      modules={[EffectFade, Autoplay]}
      effect="fade"
      fadeEffect={{ crossFade: true }}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      loop={true}
    >
      <SwiperSlide>
        <div className="news-updates-slide">
          <img
            src="https://ik.imagekit.io/wwg4nuz3a/news-and-updates/fla-2026?tr=w-1200,f-auto,q-80 1200w"
            srcSet="
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/fla-2026?tr=w-400,fo-auto,q-70 400w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/fla-2026?tr=w-800,fo-auto,q-70 800w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/fla-2026?tr=w-1200,fo-auto,q-70 1200w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/fla-2026?tr=w-1920,fo-auto,q-80 1920w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/fla-2026?tr=w-2560,fo-auto,q-80 2560w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/fla-2026?tr=w-3840,fo-auto,q-80 3840w
            "
            // sizes="
            //   (max-width: 640px) 390px,
            //   (max-width: 1024px) 50vw, 30vw
            // "
          />
          <div className="content">
            <h4>Future Leaders Academy 2026</h4>
            <p>Congratulations to the 16 delegates from JCI Lucena.</p>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="news-updates-slide">
          <img
            src="https://ik.imagekit.io/wwg4nuz3a/news-and-updates/mid-year-2026?tr=w-1200,f-auto,q-80 1200w"
            srcSet="
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/mid-year-2026?tr=w-400,fo-auto,q-70 400w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/mid-year-2026?tr=w-800,fo-auto,q-70 800w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/mid-year-2026?tr=w-1200,fo-auto,q-70 1200w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/mid-year-2026?tr=w-1920,fo-auto,q-80 1920w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/mid-year-2026?tr=w-2560,fo-auto,q-80 2560w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/mid-year-2026?tr=w-3840,fo-auto,q-80 3840w
            "
            // sizes="
            //   (max-width: 640px) 390px,
            //   (max-width: 1024px) 50vw, 30vw
            // "
          />
          <div className="content">
            <h4>Mid Year Academy 2026</h4>
            <p>Congratulations Atty. Ron Salamillas JCI Lucena 2026 LO president</p>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="news-updates-slide">
          <img
            srcSet="
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/aspac?tr=w-400,fo-auto,q-70 400w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/aspac?tr=w-800,fo-auto,q-70 800w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/aspac?tr=w-1200,fo-auto,q-70 1200w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/aspac?tr=w-1920,fo-auto,q-80 1920w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/aspac?tr=w-2560,fo-auto,q-80 2560w,
              https://ik.imagekit.io/wwg4nuz3a/news-and-updates/aspac?tr=w-3840,fo-auto,q-80 3840w
            "
            // sizes="
            //   (max-width: 640px) 390px,
            //   (max-width: 1024px) 50vw, 30vw
            // "
          />
          <div className="content">
            <h4>Asia-Pacific Conference 2026</h4>
            <p>JCI Lucena's official delegates Pert Lagman 2026 LO Immediate Past President and Patricia Lagman 2026 LO Executive Vice President</p>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  )
}

export default NewsAndUpdates